<template>
  <Modal v-model="modifyLogisticsAddressModal" :title="$t('key1006014')" width="750" :transfer="false"
    :mask-closable="false" @on-visible-change="modifyLogisticsAddressChange">
    <h2 class="mb10 font-weight-bold color-333 font-size-15">{{ $t('key1006015') }}</h2>
    <div class="flex align-items-center justify-content-between">
      <div class="ptb12 pl10 pr10 back-fff width_370">
        <h2 class="font-weight-bold color-333 font-size-14 mb5">{{ $t('key1006016') }}</h2>
        <p class="mb5">
          <Icon type="ios-contact-outline" size="18"/>
          <span class="ml5">{{ $t('key1006017') }} / ID</span>
        </p>
        <p class="mb5 ellipsisNameInfo" :title="originalAddressInfo.buyerName + ' / ' + originalAddressInfo.buyerAccountId">
          {{ (originalAddressInfo.buyerName || '-') + ' / ' + (originalAddressInfo.buyerAccountId || '-') }}
        </p>
        <Divider style="margin: 8px 0"/>
        <p class="mb5">
          <Icon type="md-phone-portrait" size="18"/>
          <span class="ml5">{{ $t('key1006018') }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>Email：</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerEmail">{{ originalAddressInfo.buyerEmail || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>Phone：</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerMobile">{{ originalAddressInfo.buyerMobile || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001175') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerPhone">{{ originalAddressInfo.buyerPhone || '-' }}</span>
        </p>
        <Divider style="margin: 8px 0"/>
        <p class="mb5">
          <Icon type="ios-home" size="18"/>
          <span class="ml5">{{ $t('key1005971') }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1004392') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerAddress1">{{ originalAddressInfo.buyerAddress1 || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1004393') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerAddress2">{{ originalAddressInfo.buyerAddress2 || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1002598') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerCountryCode">{{ originalAddressInfo.buyerCountryCode || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001162') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerState">{{ originalAddressInfo.buyerState || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001164') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerCity">{{ originalAddressInfo.buyerCity || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001170') }}</span>
          <span class="ellipsisInfo" :title="originalAddressInfo.buyerPostalCode">{{ originalAddressInfo.buyerPostalCode || '-' }}</span>
        </p>
      </div>
      <div class="ptb12 pl10 pr10 back-fff width_370">
        <h2 class="font-weight-bold color-333 font-size-14 mb5">{{ $t('key1006019') }}</h2>
        <p class="mb5">
          <Icon type="ios-contact-outline" size="18"/>
          <span class="ml5">{{ $t('key1006017') }} / ID</span>
        </p>
        <p class="mb5 ellipsisNameInfo" :title="newAddressInfo.buyerName + ' / ' + newAddressInfo.buyerAccountId">
          {{ (newAddressInfo.buyerName || '-') + ' / ' + (newAddressInfo.buyerAccountId || '-') }}
        </p>
        <Divider style="margin: 8px 0"/>
        <p class="mb5">
          <Icon type="md-phone-portrait" size="18"/>
          <span class="ml5">{{ $t('key1006018') }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>Email：</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerEmail">{{ newAddressInfo.buyerEmail || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>Phone：</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerMobile">{{ newAddressInfo.buyerMobile || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001175') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerPhone">{{ newAddressInfo.buyerPhone || '-' }}</span>
        </p>
        <Divider style="margin: 8px 0"/>
        <p class="mb5">
          <Icon type="ios-home" size="18"/>
          <span class="ml5">{{ $t('key1005971') }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1004392') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerAddress1">{{ newAddressInfo.buyerAddress1 || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1004393') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerAddress2">{{ newAddressInfo.buyerAddress2 || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1002598') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerCountryCode">{{ newAddressInfo.buyerCountryCode || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001162') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerState">{{ newAddressInfo.buyerState || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001164') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerCity">{{ newAddressInfo.buyerCity || '-' }}</span>
        </p>
        <p class="mb5 flex align-items-center">
          <span>{{ $t('key1001170') }}</span>
          <span class="ellipsisInfo" :title="newAddressInfo.buyerPostalCode">{{ newAddressInfo.buyerPostalCode || '-' }}</span>
        </p>
      </div>
    </div>
    <template #footer>
      <Button class="mr15" @click="modifyLogisticsAddressModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="modifyLogisticsAddressBtn">{{ $t('key1003503') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'modifyLogisticsAddressModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      modifyLogisticsAddressModal: false,
      newAddressInfo: {}, // 新地址
      originalAddressInfo: {}, // 原地址
      ymsPlatformOrderId: null,
    };
  },
  methods: {
    // 初始化数据
    initModifyLogisticsAddressData(obj) {
      this.ymsPlatformOrderId = obj.ymsPlatformOrderId;
      // 新地址
      this.newAddressInfo = obj;
      // 原地址
      let ymsPlatformOrderPackageRelateds = obj.ymsPlatformOrderPackageRelateds || [];
      if (ymsPlatformOrderPackageRelateds.length > 0) {
        let list = ymsPlatformOrderPackageRelateds.filter((item) => {
          return item.ymsPackageInfo && item.ymsPackageInfo.status !== 8;
        });
        let {ymsPackageInfo} = list[0];
        this.originalAddressInfo = ymsPackageInfo;
      }
      this.modifyLogisticsAddressModal = true;
    },
    // 修改
    modifyLogisticsAddressBtn() {
      let v = this;
      v.axios.put(api.put_ymsPlatformOrder_confirmModiftAddress + v.ymsPlatformOrderId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          v.modifyLogisticsAddressModal = false;
          let data = res.data.datas;
          if (data) {
            if (data.success) {
              v.modifyLogisticsAddressModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
              v.$emit('updateData', true);
            } else {
              let errorMsg = data.errorMsg;
              let content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006010')}${errorMsg}`;
              v.$Modal.confirm({
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006011'),
                content: content,
                okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006012'),
                cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006013'),
                onOk: () => {
                  v.axios.put(api.put_ymsPlatformOrder_handModiftAddress + v.ymsPlatformOrderId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
                    if (res.data.code === 0) {
                      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                      v.modifyLogisticsAddressModal = false;
                      v.$emit('updateData', true);
                    }
                  });
                },
                onCancel: () => {
                  v.modifyLogisticsAddressBtn();
                }
              });
            }
          }
        }
      });
    },
    // 监听弹窗
    modifyLogisticsAddressChange(value) {
      if (!value) {
        this.newAddressInfo = {};
        this.originalAddressInfo = {};
      }
    }
  }
};
</script>

<style lang="less">
.ellipsisInfo {
  display: inline-block;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsisNameInfo {
  display: inline-block;
  max-width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
